import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../Translations';
import GroupParticipantsStore from '../../../Group/GroupParticipantsStore/Store';
import { GroupParticipantsResource } from '../../../Group/GroupParticipantsStore/Types';
import AddParticipantStore from '../../Store';
import { resetModal } from './ModalState';

export interface Props {
  store: AddParticipantStore;
  groupParticipantsResource: GroupParticipantsResource;
  groupParticipantsStore: GroupParticipantsStore;
  participantsAdded: number;
}

const Body: React.FC<Props> = ({
  store,
  groupParticipantsResource,
  groupParticipantsStore,
  participantsAdded,
}) => (
  <>
    <div className="font-semibold text-2xl">
      <T kind="Participants Added" />
    </div>
    <div className="mt-4">
      <T
        kind="You added {{count}} new participant to {{name}}."
        count={participantsAdded}
        name={groupParticipantsResource.payload.name}
      />
    </div>
    <div
      className={clsx(
        'rounded-md cursor-pointer bg-teal-600 text-white px-3 py-2 text-sm w-1/2 text-center mt-20 mb-16 mx-auto',
      )}
      onClick={() => resetModal(store, groupParticipantsResource, groupParticipantsStore)}
    >
      <T kind="Done" />
    </div>
  </>
);

export default observer(Body);
